export default __webpack_public_path__ + "static/media/404.e9b42489.png";